import { defineComponent as P, ref as I, onUnmounted as N, watch as j, openBlock as M, createElementBlock as R, unref as k, normalizeStyle as L } from "vue";
var p = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, C = {}, E = {}, h = p && p.__assign || function() {
  return h = Object.assign || function(t) {
    for (var r, e = 1, o = arguments.length; e < o; e++) {
      r = arguments[e];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (t[a] = r[a]);
    }
    return t;
  }, h.apply(this, arguments);
};
Object.defineProperty(E, "__esModule", { value: !0 });
var F = {
  delayFirstAttempt: !1,
  jitter: "none",
  maxDelay: 1 / 0,
  numOfAttempts: 10,
  retry: function() {
    return !0;
  },
  startingDelay: 100,
  timeMultiple: 2
};
function x(t) {
  var r = h(h({}, F), t);
  return r.numOfAttempts < 1 && (r.numOfAttempts = 1), r;
}
E.getSanitizedOptions = x;
var w = {}, b = {}, _ = {}, O = {}, A = {};
Object.defineProperty(A, "__esModule", { value: !0 });
function U(t) {
  var r = Math.random() * t;
  return Math.round(r);
}
A.fullJitter = U;
var D = {};
Object.defineProperty(D, "__esModule", { value: !0 });
function J(t) {
  return t;
}
D.noJitter = J;
Object.defineProperty(O, "__esModule", { value: !0 });
var G = A, H = D;
function $(t) {
  switch (t.jitter) {
    case "full":
      return G.fullJitter;
    case "none":
    default:
      return H.noJitter;
  }
}
O.JitterFactory = $;
Object.defineProperty(_, "__esModule", { value: !0 });
var B = O, Y = (
  /** @class */
  function() {
    function t(r) {
      this.options = r, this.attempt = 0;
    }
    return t.prototype.apply = function() {
      var r = this;
      return new Promise(function(e) {
        return setTimeout(e, r.jitteredDelay);
      });
    }, t.prototype.setAttemptNumber = function(r) {
      this.attempt = r;
    }, Object.defineProperty(t.prototype, "jitteredDelay", {
      get: function() {
        var r = B.JitterFactory(this.options);
        return r(this.delay);
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(t.prototype, "delay", {
      get: function() {
        var r = this.options.startingDelay, e = this.options.timeMultiple, o = this.numOfDelayedAttempts, a = r * Math.pow(e, o);
        return Math.min(a, this.options.maxDelay);
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(t.prototype, "numOfDelayedAttempts", {
      get: function() {
        return this.attempt;
      },
      enumerable: !0,
      configurable: !0
    }), t;
  }()
);
_.Delay = Y;
var z = p && p.__extends || function() {
  var t = function(r, e) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(o, a) {
      o.__proto__ = a;
    } || function(o, a) {
      for (var n in a)
        a.hasOwnProperty(n) && (o[n] = a[n]);
    }, t(r, e);
  };
  return function(r, e) {
    t(r, e);
    function o() {
      this.constructor = r;
    }
    r.prototype = e === null ? Object.create(e) : (o.prototype = e.prototype, new o());
  };
}(), q = p && p.__awaiter || function(t, r, e, o) {
  function a(n) {
    return n instanceof e ? n : new e(function(l) {
      l(n);
    });
  }
  return new (e || (e = Promise))(function(n, l) {
    function f(s) {
      try {
        i(o.next(s));
      } catch (u) {
        l(u);
      }
    }
    function d(s) {
      try {
        i(o.throw(s));
      } catch (u) {
        l(u);
      }
    }
    function i(s) {
      s.done ? n(s.value) : a(s.value).then(f, d);
    }
    i((o = o.apply(t, r || [])).next());
  });
}, Q = p && p.__generator || function(t, r) {
  var e = { label: 0, sent: function() {
    if (n[0] & 1)
      throw n[1];
    return n[1];
  }, trys: [], ops: [] }, o, a, n, l;
  return l = { next: f(0), throw: f(1), return: f(2) }, typeof Symbol == "function" && (l[Symbol.iterator] = function() {
    return this;
  }), l;
  function f(i) {
    return function(s) {
      return d([i, s]);
    };
  }
  function d(i) {
    if (o)
      throw new TypeError("Generator is already executing.");
    for (; e; )
      try {
        if (o = 1, a && (n = i[0] & 2 ? a.return : i[0] ? a.throw || ((n = a.return) && n.call(a), 0) : a.next) && !(n = n.call(a, i[1])).done)
          return n;
        switch (a = 0, n && (i = [i[0] & 2, n.value]), i[0]) {
          case 0:
          case 1:
            n = i;
            break;
          case 4:
            return e.label++, { value: i[1], done: !1 };
          case 5:
            e.label++, a = i[1], i = [0];
            continue;
          case 7:
            i = e.ops.pop(), e.trys.pop();
            continue;
          default:
            if (n = e.trys, !(n = n.length > 0 && n[n.length - 1]) && (i[0] === 6 || i[0] === 2)) {
              e = 0;
              continue;
            }
            if (i[0] === 3 && (!n || i[1] > n[0] && i[1] < n[3])) {
              e.label = i[1];
              break;
            }
            if (i[0] === 6 && e.label < n[1]) {
              e.label = n[1], n = i;
              break;
            }
            if (n && e.label < n[2]) {
              e.label = n[2], e.ops.push(i);
              break;
            }
            n[2] && e.ops.pop(), e.trys.pop();
            continue;
        }
        i = r.call(t, e);
      } catch (s) {
        i = [6, s], a = 0;
      } finally {
        o = n = 0;
      }
    if (i[0] & 5)
      throw i[1];
    return { value: i[0] ? i[1] : void 0, done: !0 };
  }
};
Object.defineProperty(b, "__esModule", { value: !0 });
var V = _, W = (
  /** @class */
  function(t) {
    z(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r.prototype.apply = function() {
      return q(this, void 0, void 0, function() {
        return Q(this, function(e) {
          return [2, this.isFirstAttempt ? !0 : t.prototype.apply.call(this)];
        });
      });
    }, Object.defineProperty(r.prototype, "isFirstAttempt", {
      get: function() {
        return this.attempt === 0;
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(r.prototype, "numOfDelayedAttempts", {
      get: function() {
        return this.attempt - 1;
      },
      enumerable: !0,
      configurable: !0
    }), r;
  }(V.Delay)
);
b.SkipFirstDelay = W;
var T = {}, X = p && p.__extends || function() {
  var t = function(r, e) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(o, a) {
      o.__proto__ = a;
    } || function(o, a) {
      for (var n in a)
        a.hasOwnProperty(n) && (o[n] = a[n]);
    }, t(r, e);
  };
  return function(r, e) {
    t(r, e);
    function o() {
      this.constructor = r;
    }
    r.prototype = e === null ? Object.create(e) : (o.prototype = e.prototype, new o());
  };
}();
Object.defineProperty(T, "__esModule", { value: !0 });
var K = _, Z = (
  /** @class */
  function(t) {
    X(r, t);
    function r() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return r;
  }(K.Delay)
);
T.AlwaysDelay = Z;
Object.defineProperty(w, "__esModule", { value: !0 });
var tt = b, et = T;
function nt(t, r) {
  var e = rt(t);
  return e.setAttemptNumber(r), e;
}
w.DelayFactory = nt;
function rt(t) {
  return t.delayFirstAttempt ? new et.AlwaysDelay(t) : new tt.SkipFirstDelay(t);
}
var v = p && p.__awaiter || function(t, r, e, o) {
  function a(n) {
    return n instanceof e ? n : new e(function(l) {
      l(n);
    });
  }
  return new (e || (e = Promise))(function(n, l) {
    function f(s) {
      try {
        i(o.next(s));
      } catch (u) {
        l(u);
      }
    }
    function d(s) {
      try {
        i(o.throw(s));
      } catch (u) {
        l(u);
      }
    }
    function i(s) {
      s.done ? n(s.value) : a(s.value).then(f, d);
    }
    i((o = o.apply(t, r || [])).next());
  });
}, g = p && p.__generator || function(t, r) {
  var e = { label: 0, sent: function() {
    if (n[0] & 1)
      throw n[1];
    return n[1];
  }, trys: [], ops: [] }, o, a, n, l;
  return l = { next: f(0), throw: f(1), return: f(2) }, typeof Symbol == "function" && (l[Symbol.iterator] = function() {
    return this;
  }), l;
  function f(i) {
    return function(s) {
      return d([i, s]);
    };
  }
  function d(i) {
    if (o)
      throw new TypeError("Generator is already executing.");
    for (; e; )
      try {
        if (o = 1, a && (n = i[0] & 2 ? a.return : i[0] ? a.throw || ((n = a.return) && n.call(a), 0) : a.next) && !(n = n.call(a, i[1])).done)
          return n;
        switch (a = 0, n && (i = [i[0] & 2, n.value]), i[0]) {
          case 0:
          case 1:
            n = i;
            break;
          case 4:
            return e.label++, { value: i[1], done: !1 };
          case 5:
            e.label++, a = i[1], i = [0];
            continue;
          case 7:
            i = e.ops.pop(), e.trys.pop();
            continue;
          default:
            if (n = e.trys, !(n = n.length > 0 && n[n.length - 1]) && (i[0] === 6 || i[0] === 2)) {
              e = 0;
              continue;
            }
            if (i[0] === 3 && (!n || i[1] > n[0] && i[1] < n[3])) {
              e.label = i[1];
              break;
            }
            if (i[0] === 6 && e.label < n[1]) {
              e.label = n[1], n = i;
              break;
            }
            if (n && e.label < n[2]) {
              e.label = n[2], e.ops.push(i);
              break;
            }
            n[2] && e.ops.pop(), e.trys.pop();
            continue;
        }
        i = r.call(t, e);
      } catch (s) {
        i = [6, s], a = 0;
      } finally {
        o = n = 0;
      }
    if (i[0] & 5)
      throw i[1];
    return { value: i[0] ? i[1] : void 0, done: !0 };
  }
};
Object.defineProperty(C, "__esModule", { value: !0 });
var it = E, at = w;
function ot(t, r) {
  return r === void 0 && (r = {}), v(this, void 0, void 0, function() {
    var e, o;
    return g(this, function(a) {
      switch (a.label) {
        case 0:
          return e = it.getSanitizedOptions(r), o = new ut(t, e), [4, o.execute()];
        case 1:
          return [2, a.sent()];
      }
    });
  });
}
var st = C.backOff = ot, ut = (
  /** @class */
  function() {
    function t(r, e) {
      this.request = r, this.options = e, this.attemptNumber = 0;
    }
    return t.prototype.execute = function() {
      return v(this, void 0, void 0, function() {
        var r, e;
        return g(this, function(o) {
          switch (o.label) {
            case 0:
              if (this.attemptLimitReached)
                return [3, 7];
              o.label = 1;
            case 1:
              return o.trys.push([1, 4, , 6]), [4, this.applyDelay()];
            case 2:
              return o.sent(), [4, this.request()];
            case 3:
              return [2, o.sent()];
            case 4:
              return r = o.sent(), this.attemptNumber++, [4, this.options.retry(r, this.attemptNumber)];
            case 5:
              if (e = o.sent(), !e || this.attemptLimitReached)
                throw r;
              return [3, 6];
            case 6:
              return [3, 0];
            case 7:
              throw new Error("Something went wrong.");
          }
        });
      });
    }, Object.defineProperty(t.prototype, "attemptLimitReached", {
      get: function() {
        return this.attemptNumber >= this.options.numOfAttempts;
      },
      enumerable: !0,
      configurable: !0
    }), t.prototype.applyDelay = function() {
      return v(this, void 0, void 0, function() {
        var r;
        return g(this, function(e) {
          switch (e.label) {
            case 0:
              return r = at.DelayFactory(this.options, this.attemptNumber), [4, r.apply()];
            case 1:
              return e.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t;
  }()
), lt = ((t) => (t.reactUi = "client-sdk-react-ui", t.vanillaUi = "client-sdk-vanilla-ui", t))(lt || {}), ct = ((t) => (t.prod = "https://www.crossmint.com", t.staging = "https://staging.crossmint.com", t.dev = "http://localhost:3001", t))(ct || {}), ft = ((t) => (t.clientVersion = "X-Client-Version", t.clientName = "X-Client-Name", t))(ft || {}), dt = ((t) => (t.CANDY_MACHINE = "candy-machine", t.SOLANA_AUCTION = "solana-auction", t.ERC_721 = "erc-721", t))(dt || {}), pt = ((t) => (t.WAITING_SUBMISSION = "waiting-submission", t.PENDING = "pending", t.REJECTED = "rejected", t.ACCEPTED = "accepted", t.INVALID = "invalid", t))(pt || {}), S = (t = "") => t === "staging" ? "https://staging.crossmint.com" : ["prod", "production"].includes(t) || !t ? "https://www.crossmint.com" : t, yt = { PAYMENT_PREPARATION_FAILED: "payment:preparation.failed", PAYMENT_PROCESS_CANCELED: "payment:process.canceled", PAYMENT_PROCESS_REJECTED: "payment:process.rejected" }, mt = { PAYMENT_PREPARATION_SUCCEEDED: "payment:preparation.succeeded", PAYMENT_PROCESS_STARTED: "payment:process.started", PAYMENT_PROCESS_SUCCEEDED: "payment:process.succeeded", ...yt }, ht = { ORDER_PROCESS_STARTED: "order:process.started", ORDER_PROCESS_FINISHED: "order:process.finished" }, _t = { QUOTE_STATUS_CHANGED: "quote:status.changed", QUOTE_STATUS_INVALIDATED: "quote:status.invalidated" }, vt = { RECIPIENT_WALLET_CHANGED: "recipient:wallet.changed" }, gt = { TRANSACTION_FULFILLMENT_FAILED: "transaction:fulfillment.failed" }, Et = { TRANSACTION_FULFILLMENT_SUCCEEDED: "transaction:fulfillment.succeeded", ...gt }, m = { ...mt, ...ht, ..._t, ...vt, ...Et }, wt = { PARAMS_UPDATE: "params-update" }, bt = { UI_HEIGHT_CHANGED: "ui:height.changed" };
function Ot({ clientId: t, uiConfig: r, recipient: e, environment: o, mintConfig: a, locale: n, whPassThroughArgs: l }) {
  let f = S(o);
  function d() {
    let u = new URLSearchParams({ clientId: t });
    return r != null && u.append("uiConfig", JSON.stringify(r)), e != null && u.append("recipient", JSON.stringify(e)), a != null && u.append("mintConfig", JSON.stringify(a)), n != null && u.append("locale", n), l != null && u.append("whPassThroughArgs", JSON.stringify(l)), `${f}/sdk/paymentElement?${u.toString()}`;
  }
  function i(u) {
    function c(y) {
      y.origin === f && Object.values(m).includes(y.data.type) && u(y);
    }
    return window.addEventListener("message", c), () => {
      window.removeEventListener("message", c);
    };
  }
  function s(u) {
    var c;
    let y = document.getElementById("iframe-crossmint-payment-element");
    (c = y == null ? void 0 : y.contentWindow) == null || c.postMessage({ type: wt.PARAMS_UPDATE, payload: u }, f);
  }
  return { getIframeUrl: d, listenToEvents: i, emitQueryParams: s };
}
function It({ environment: t } = {}) {
  function r({ orderIdentifier: o }, a) {
    let n = [], l = [], f = [];
    function d(c) {
      a(c), n.push(c.type), c.type === m.ORDER_PROCESS_FINISHED && clearInterval(u);
    }
    function i(c) {
      if (c.payload.transactionIdentifier) {
        if (c.type === m.TRANSACTION_FULFILLMENT_SUCCEEDED) {
          if (l.includes(c.payload.transactionIdentifier))
            return;
          l.push(c.payload.transactionIdentifier), d(c);
        } else if (c.type === m.TRANSACTION_FULFILLMENT_FAILED) {
          if (f.includes(c.payload.transactionIdentifier))
            return;
          f.push(c.payload.transactionIdentifier), d(c);
        }
      }
    }
    let s = !1, u = setInterval(async () => {
      if (s)
        return;
      s = !0;
      let c = await e({ orderIdentifier: o });
      for (let y of c)
        n.includes(y.type) ? i(y) : d(y);
      s = !1;
    }, 5e3);
    window.onpopstate = () => {
      s = !1, clearInterval(u);
    };
  }
  async function e({ orderIdentifier: o }) {
    return await st(async () => {
      let a = await (await fetch(`${S(t)}/api/sdk/orders/${o}/status`, { method: "GET", headers: {} })).json();
      return a.error ? [] : a;
    }, { startingDelay: 650, timeMultiple: 2.5, numOfAttempts: 5 });
  }
  return { listenToMintingEvents: r };
}
function At({ environment: t } = {}) {
  let r = S(t);
  function e(o) {
    function a(n) {
      n.origin === r && Object.values(bt).includes(n.data.type) && o(n);
    }
    return window.addEventListener("message", a), () => {
      window.removeEventListener("message", a);
    };
  }
  return { listenToEvents: e };
}
const Dt = ["src"], Tt = /* @__PURE__ */ P({
  __name: "CrossmintPaymentElement",
  props: {
    clientId: null,
    mintConfig: null,
    recipient: null,
    paymentMethod: null,
    currency: null,
    locale: null,
    uiConfig: null,
    environment: null,
    whPassThroughArgs: null,
    onEvent: null
  },
  setup(t) {
    const r = t, { getIframeUrl: e, listenToEvents: o, emitQueryParams: a } = Ot(r), { listenToEvents: n } = At({ environment: r.environment }), l = e(), f = I(0), d = o((s) => {
      var u;
      return (u = r.onEvent) == null ? void 0 : u.call(r, s.data);
    }), i = n((s) => {
      const { type: u, payload: c } = s.data;
      switch (u) {
        case "ui:height.changed":
          f.value = c.height;
          break;
        default:
          return;
      }
    });
    return N(() => {
      d(), i();
    }), j(
      () => [r.recipient, r.mintConfig, r.locale, r.whPassThroughArgs],
      () => {
        a({
          recipient: r.recipient,
          mintConfig: r.mintConfig,
          locale: r.locale,
          whPassThroughArgs: r.whPassThroughArgs
        });
      },
      { deep: !0 }
    ), (s, u) => (M(), R("iframe", {
      src: k(l),
      allow: "payment *",
      id: "iframe-crossmint-payment-element",
      style: L({ height: `${f.value}px` })
    }, null, 12, Dt));
  }
});
const St = (t, r) => {
  const e = t.__vccOpts || t;
  for (const [o, a] of r)
    e[o] = a;
  return e;
}, Ct = /* @__PURE__ */ St(Tt, [["__scopeId", "data-v-d5b30284"]]), Nt = {
  install: (t) => {
    t.component("CrossmintPaymentElement", Ct);
  }
};
export {
  m as CheckoutEvents,
  Ct as CrossmintPaymentElement,
  Nt as default,
  It as useCrossmintEvents
};
